import { XmSdk } from "../nwaswebsdk/js-es6/xmsdk-es6";
import CustomUiHandler from "./customUiHandler";

export default class TransmitService {
  constructor(context) {
    this.sdk = XmSdk();
    this.context = context;
  }

  getContext() {
    return this.context;
  }

  startInit(endpoint, realm, appId, uiHandlerType) {
    let othis = this;
    return new Promise(function (resolve, reject) {
      let connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(
        endpoint,
        appId
      );
      if (realm) {
        connectionSettings.setRealm(realm);
      }
      othis.sdk.setConnectionSettings(connectionSettings);

      switch (uiHandlerType) {
        case "custom":
          othis.sdk.setUiHandler(new CustomUiHandler(othis.context));
          break;
        default:
          othis.sdk.setUiHandler(new xmui.XmUIHandler());
      }

      othis.sdk
        .initialize()
        .then(function () {
          resolve(true);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  doLogout() {
    let othis = this;
    return new Promise(function (resolve, reject) {
      othis.sdk
        .logout()
        .then(function () {
          resolve(true);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  handleAuthError(err) {
    let othis = this;
    return new Promise(function (resolve, reject) {
      if (err.getErrorCode && err.getErrorCode() === 8) {
        othis
          .doLogout()
          .then(function () {
            resolve("retry");
          })
          .catch((logout_err) => {
            console.error(
              "Error logging out of Transmit session: \n" + logout_err
            );
            resolve("fatal");
          });
      } else {
        resolve("fatal");
      }
    });
  }

  startAuth(selectedUser, policyId, parms, clientContext) {
    let othis = this;
    return new Promise(function (resolve, reject) {
      othis.sdk
        .authenticate(selectedUser, policyId, parms, clientContext)
        .then(function (successfulAuth) {
          resolve(successfulAuth);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  startUserlessAuth(policyId, parms, clientContext) {
    let othis = this;
    return new Promise(function (resolve, reject) {
      othis.sdk
        .invokeAnonymousPolicy(policyId, parms, clientContext)
        .then(function (successfulAuth) {
          resolve(successfulAuth);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  onInvoke(journeyId, parameters, clientContext) {
    let othis = this;
    return new Promise(function (resolve, reject) {
      othis.sdk
        .invokePolicy(journeyId, parameters, clientContext)
        .then(function (successfulAuth) {
          resolve(successfulAuth);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }
}
